"use strict";

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getFeatureName, setFeatureName } from '@autoguru/feature-identification';
import { createContext, useContext, useEffect, useMemo } from 'react';
import { createDualLoggingAgent } from '../adapters';
import { initializeDataDogRUM } from '../datadog';
import { createLoggingAgent } from '../new-relic';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoggingAgentContext = /*#__PURE__*/createContext(null);
export const LoggingAgentProvider = ({
  children,
  options,
  agentIdentifier: _agentIdentifier = getFeatureName(),
  enableDataDog: _enableDataDog = true
}) => {
  setFeatureName({
    mfeAppName: __GDU_APP_NAME__
  });

  // Initialize DataDog RUM (external system) - safe to call multiple times due to singleton guard
  useEffect(() => {
    if (_enableDataDog && process.__browser__) {
      var _GDU_APP_NAME__;
      initializeDataDogRUM({
        service: (_GDU_APP_NAME__ = __GDU_APP_NAME__) === null || _GDU_APP_NAME__ === void 0 ? void 0 : _GDU_APP_NAME__.replace('@autoguru/', ''),
        env: process.env.NODE_ENV || 'production'
      });
    }
  }, [_enableDataDog]);
  const agent = useMemo(() => {
    const newRelicAgent = createLoggingAgent({
      options,
      agentIdentifier: _agentIdentifier
    });
    return createDualLoggingAgent(newRelicAgent, _enableDataDog);
  }, [options, _agentIdentifier, _enableDataDog]);
  return /*#__PURE__*/_jsx(LoggingAgentContext.Provider, {
    value: agent,
    children: children
  });
};
const isBrowser = typeof window !== 'undefined';
export const useLoggingAgent = () => {
  return isBrowser ? useContext(LoggingAgentContext) : null;
};